import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { AssociateCustomerType as CustomerType, MailMerge, MessageType, TaskOutcome } from '@quorum/models/xs-resource';
import { map } from 'rxjs/operators';
import * as fromCustomerTypes from './customer-types/customer-types.actions';
import { CustomerTypesState } from './customer-types/customer-types.interfaces';
import * as fromMailMerges from './mail-merges/mail-merges.actions';
import * as fromMessageTypes from './message-types/message-types.actions';
import { MessageTypesState } from './message-types/message-types.interfaces';
import * as fromTaskOutcomes from './task-outcomes/task-outcomes.actions';
import { TaskOutcomesState } from './task-outcomes/task-outcomes.interfaces';

@Injectable()
export class DropdownEffects {
  
  getCustomerTypesFromServer = createEffect(() => this.dataPersistence.fetch(fromCustomerTypes.GET_CUSTOMER_TYPES_FROM_SERVER, {
    run: (action: fromCustomerTypes.GetAssociateCustomerTypesFromServer, state: CustomerTypesState) => {
      return this.apiService
        .get<CustomerType[]>(`v/1/associates/customer-types`, {
          params: action.payload,
        })
        .pipe(
          map((customerTypes: CustomerType[]) => {
            return new fromCustomerTypes.GetAssociateCustomerTypesFromServerSuccess({
              customerTypes: customerTypes,
            });
          })
        );
    },
    onError: (action: fromCustomerTypes.GetAssociateCustomerTypesFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  getMailMergesFromServer = createEffect(() => this.dataPersistence.fetch(fromMailMerges.GET_MAIL_MERGES_FROM_SERVER, {
    run: (action: fromMailMerges.GetMailMergesFromServer, state: CustomerTypesState) => {
      return this.apiService
        .get<CustomerType[]>(`v/1/system/mail-merges`, {
          params: action.payload,
        })
        .pipe(
          map((mailMerges: MailMerge[]) => {
            return new fromMailMerges.GetMailMergesFromServerSuccess({
              mailMerges: mailMerges,
            });
          })
        );
    },
    onError: (action: fromMailMerges.GetMailMergesFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  getMessageTypesFromServer = createEffect(() => this.dataPersistence.fetch(fromMessageTypes.GET_MESSAGE_TYPES_FROM_SERVER, {
    run: (action: fromMessageTypes.GetAssociateMessageTypesFromServer, state: MessageTypesState) => {
      return this.apiService
        .get<MessageType[]>(`v/1/associates/message-types`, {
          params: action.payload,
        })
        .pipe(
          map((messageTypes: MessageType[]) => {
            return new fromMessageTypes.GetAssociateMessageTypesFromServerSuccess({
              messageTypes: messageTypes,
            });
          })
        );
    },
    onError: (action: fromMessageTypes.GetAssociateMessageTypesFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  getTaskOutcomes = createEffect(() => this.dataPersistence.fetch(fromTaskOutcomes.GET_TASK_OUTCOMES_FROM_SERVER, {
    run: (action: fromTaskOutcomes.GetTaskOutcomesFromServer, state: TaskOutcomesState) => {
      return this.apiService
        .get<TaskOutcome[]>(`v/1/crm/task-outcomes`, {
          params: action.payload,
        })
        .pipe(
          map((taskOutcomes: TaskOutcome[]) => {
            return new fromTaskOutcomes.GetTaskOutcomesFromServerSuccess({
              taskOutcomes: taskOutcomes,
            });
          })
        );
    },
    onError: (action: fromTaskOutcomes.GetTaskOutcomesFromServer, error) => {
      console.error('Error', error);
    },
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService
  ) {}
}
